module.exports = __webpack_public_path__ + "static/img/AI穿透式监管方案_场景一.45ef47f4.png";